module.exports = __webpack_public_path__ + "img/data_bg_r.727b885a.png";